export default class BulletsAnimation {
	constructor(containerSelector, id, bulletsClasses, count = 10, clockPeriodMs = 100) {
		this.containerSelector = containerSelector;
		this.bulletsClasses = bulletsClasses;
		this.id = id;
		this.count = count;
		this.clockPeriodMs = clockPeriodMs;
	}

	createAndRun(backward = false, containerLayerOverride = null) {
		this.backward = backward;
		const jOverlayLayer = $(containerLayerOverride || this.containerSelector);
		if (jOverlayLayer && jOverlayLayer.length) {
			const jBullets = jOverlayLayer.find(`#${this.id}`);
			if (!jBullets || !jBullets.length) {
				const bullet4Animation = this.createBullets(this.count);
				jOverlayLayer[0].appendChild(bullet4Animation);
			} else {
				jBullets.removeClass('inactive');
			}
			if (backward) this.startReloadingSpinnerBack();
			else this.startReloadingSpinner();
		}
	}

	createBullets(count) {
		// this.bulletCount = count;
		const bulletsLayer = document.createElement('div');
		$(bulletsLayer).addClass(this.bulletsClasses.join(' '));
		$(bulletsLayer).attr('aria-hidden', 'true');
		bulletsLayer.id = this.id;
		bulletsLayer.style.opacity = 0;
		bulletsLayer.style.display = 'block';

		const ulContainer = document.createElement('ul');
		for (let i = 0; i < count; i++) {
			const innerLi = document.createElement('li');
			ulContainer.appendChild(innerLi);
		}
		bulletsLayer.appendChild(ulContainer);
		bulletsLayer.style.opacity = 1;
		return bulletsLayer;
	}

	activateBullet(idx) {
		$(`#${this.id} li`).removeClass('active');
		$(`#${this.id} li`).removeClass('semi-active');
		$(`#${this.id} li`).removeClass('semi-active--2');
		if (this.backward) {
			if (idx >= 0 && idx < this.count) $(`#${this.id} li:nth-child(${idx + 1})`).addClass('semi-active semi-active--2');
			if ((idx - 1) >= 0 && (idx - 1) < this.count) $(`#${this.id} li:nth-child(${idx})`).addClass('semi-active');
			if ((idx - 2) >= 0 && (idx - 2) < this.count) $(`#${this.id} li:nth-child(${idx - 1})`).addClass('active');
		}
		else {
			if (idx >= 0 && idx < this.count) $(`#${this.id} li:nth-child(${idx + 1})`).addClass('active');
			if ((idx - 1) >= 0 && (idx - 1) < this.count) $(`#${this.id} li:nth-child(${idx})`).addClass('semi-active');
			if ((idx - 2) >= 0 && (idx - 2) < this.count) $(`#${this.id} li:nth-child(${idx - 1})`).addClass('semi-active semi-active--2');
		}


	}

	destroy() {
		$(`#${this.id}`).addClass('inactive');
		$(`#${this.id} li`).removeClass('active');
		$(`#${this.id} li`).removeClass('semi-active');
		this.stopReloadSpinner();
	}

	stopReloadSpinner() {
		if (this.spinnerInterval) clearInterval(this.spinnerInterval);
		this.spinnerInterval = null;
	}

	startReloadingSpinner() {
		let idx = 0;
		if (this.spinnerInterval) clearInterval(this.spinnerInterval);
		if (this.bulletHideTimeout) clearTimeout(this.bulletHideTimeout);
		this.spinnerInterval = setInterval(() => {
			this.activateBullet(idx);
			idx++;
			if (idx > Math.round(2.2 * this.count)) idx = 0;
		}, this.clockPeriodMs);
	}

	startReloadingSpinnerBack() {
		if (this.spinnerInterval) clearInterval(this.spinnerInterval);
		if (this.bulletHideTimeout) clearTimeout(this.bulletHideTimeout);
		let idx = this.count + 2;
		this.spinnerInterval = setInterval(() => {
			this.activateBullet(idx);
			idx--;
			if (idx < 0) idx = Math.round(2.2 * this.count);
		}, this.clockPeriodMs);
	}
}
